export default __webpack_public_path__ + "static/media/cross.63b1d231.png";